(function () {
  const shopifyCategoryParam = 'filter.p.product_type';
  const btaCategoryParam = 'product_types';

  function selectedCategories() {
    return new URL(window.location.href).searchParams
      .getAll(shopifyCategoryParam)
      .map((value) => value.trim())
      .filter(Boolean);
  }

  function connectCategoryToSearch(shell) {
    const categories = selectedCategories();
    if (!categories.length) {
      shell.dataset.categoryBridge = 'not-needed';
      return true;
    }

    const frame = shell.querySelector('.bta-search-widget-container iframe');
    const wrapperId = frame?.parentElement?.id;
    const xprops = wrapperId ? window[`__btaXprops_${wrapperId}`] : null;

    if (!xprops || typeof xprops.onTrigger !== 'function') return false;
    if (xprops.onTrigger.wonCategoryBridge) return true;

    const originalOnTrigger = xprops.onTrigger;
    const bridgedOnTrigger = function (trigger, query, ...remainingArguments) {
      if (trigger === 'replace' && typeof query === 'string') {
        const params = new URLSearchParams(query);
        params.delete(btaCategoryParam);
        categories.forEach((category) => params.append(btaCategoryParam, category));
        query = params.toString();
      }

      return originalOnTrigger.call(this, trigger, query, ...remainingArguments);
    };

    bridgedOnTrigger.wonCategoryBridge = true;
    xprops.onTrigger = bridgedOnTrigger;
    shell.dataset.categoryBridge = 'ready';
    return true;
  }

  function initialize() {
    document.querySelectorAll('.availability-widget-shell').forEach((shell) => {
      if (connectCategoryToSearch(shell)) return;

      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;
        if (connectCategoryToSearch(shell) || attempts >= 80) {
          window.clearInterval(timer);
          if (attempts >= 80 && shell.dataset.categoryBridge !== 'ready') {
            shell.dataset.categoryBridge = 'unavailable';
          }
        }
      }, 250);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
